import React from 'react';
import { MdOutlineAlternateEmail } from "react-icons/md";
import { MdPhone, MdSupportAgent } from "react-icons/md"; // Import other icons as needed

function ContactObjects() {
  return (
    <div className='h-auto max-w-screen-lg px-6 py-10 mx-auto '>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-3'>
        {/* Email Box */}
        <div className='p-6 text-center bg-[#04347c] rounded-lg shadow-lg'>
          <div className='flex justify-center mb-4 text-white'>
            <MdOutlineAlternateEmail size={32} />
          </div>
          <h1 className='mb-2 text-xl font-bold text-white'>Email us:</h1>
          <p className='mb-4 text-white'>Email us for general queries, including marketing and partnership opportunities.</p>
          <div className='font-medium text-white'>sales@tissonlanka.com</div>
        </div>
        
        {/* Call Us Box */}
        <div className='p-6 text-center bg-[#04347c] rounded-lg shadow-lg'>
          <div className='flex justify-center mb-4 text-white'>
            <MdPhone size={32} />
          </div>
          <h1 className='mb-2 text-xl font-bold text-white'>Call us:</h1>
          <p className='mb-4 text-white'>Call us for immediate support and inquiries.</p>
          <div className='font-medium text-white'>+94(76) 748 8999</div>
        </div>
        
        {/* Support Box */}
        <div className='p-6 text-center bg-[#04347c] rounded-lg shadow-lg'>
          <div className='flex justify-center mb-4 text-white'>
            <MdSupportAgent size={32} />
          </div>
          <h1 className='mb-2 text-xl font-bold text-white'>Support:</h1>
          <p className='mb-4 text-white'>Get support for any issues or questions you may have.</p>
          <div className='font-medium text-white'>contact@tissonlanka.com</div>
        </div>
      </div>
    </div>
  );
}

export default ContactObjects;
